import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

export const $queuedTerminalPrompt = atomFamily((documentId: string) => {
	const promptAtom = atom(null as string | null);
	promptAtom.debugLabel = `queuedTerminalPrompt:${documentId}`;
	return promptAtom;
});
